import api from '../services/api';

// Envía un error del cliente a /errores-cliente. Nunca lanza — reportar un
// error no debe generar otro error.
export function reportarErrorCliente(tipo, mensaje, extra = {}) {
  try {
    api.post('/errores-cliente', {
      tipo,
      mensaje: String(mensaje || 'Error desconocido').slice(0, 2000),
      archivo: extra.archivo || null,
      linea: extra.linea || null,
      trace: extra.trace || null,
      url: window.location.href,
    }).catch(() => {});
  } catch {
    // no-op
  }
}
